import iconPath from '@/assets/device-icons/imac-2021.svg';

interface Imac2021IconProps {
  className?: string;
}

export const Imac2021Icon = ({ className = "h-5 w-5" }: Imac2021IconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="iMac 2021" 
      className={className}
    />
  );
};
